import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

//
import { register } from "../../redux/features/user/actions";
import { setUser } from "../../redux/features/user/slice";

//
import { Form, Button, Spinner } from "react-bootstrap";

//
import PasswordStrengthMeter from "../../components/general/PasswordStrengthMeter";

//
import AppleLogin from "./AppleLogin";
import GoogleLogin from "./GoogleLogin";
import GoogleRecaptchaModal from "../../components/auth/GoogleRecaptchaModal";

//
import { Formik } from "formik";
import * as yup from "yup";

//
const schema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
  password_confirmation: yup
    .string()
    .required()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  agree: yup.bool().required().oneOf([true], "agree must be accepted"),
});

const Register = ({ setUser }) => {
  let navigate = useNavigate();
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [score, setScore] = useState(0);
  const [password, setPassword] = useState("");

  const [passwordCanSee, setPasswordCanSee] = useState(false);
  const [passwordConfirmationCanSee, setPasswordConfirmationCanSee] =
    useState(false);

  const [userData, setUserData] = useState({
    email: "",
    password: "",
    password_confirmation: "",
    agree: false,
  });

  // Get query from url
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();

  let referral = query.get("referral");

  /**
   * Register User
   */
  const register_user = async (e) => {
    if (score >= 3) {
      // close modal
      setShow(false);

      // start loading
      setLoading(true);

      // variables
      let content = { ...userData };
      content.recaptcha = e;
      if (referral) {
        content.introducer = referral;
      }

      // request
      await register(content).then((res) => {
        if (res) {
          setUser(res);
          setLoading(false);
          navigate("/");
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  const saveData = (e) => {
    if (score >= 3) {
      let user_data = { ...userData };
      user_data.email = e.email;
      user_data.password = e.password;
      user_data.password_confirmation = e.password_confirmation;
      if (referral) {
        user_data.introducer = referral;
      }
      setUserData(user_data);
      setShow(true);
    }
  };

  return (
    <>
      <GoogleRecaptchaModal
        show={show}
        setShow={(status) => setShow(status)}
        action={register_user}
      />

      <div>
        <h3>Create an Account</h3>

        <h6 className="fw-normal text-muted">
          Enter your credentials to access your account
        </h6>

        <Formik
          validationSchema={schema}
          onSubmit={saveData}
          initialValues={{
            email: "",
            password: "",
            password_confirmation: "",
            agree: false,
          }}
        >
          {({ handleSubmit, handleChange, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group className="form-group" controlId="validationFormik02">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  placeholder="Email"
                  className="form-control"
                  onChange={handleChange}
                  autoComplete="off"
                  isInvalid={touched.email && !!errors.email}
                />
              </Form.Group>

              <Form.Group className="form-group" controlId="validationFormik02">
                <Form.Label>Password</Form.Label>
                <div className="input-holder right">
                  <Form.Control
                    type={passwordCanSee ? "text" : "password"}
                    placeholder="Enter your password"
                    name="password"
                    className="form-control"
                    onChange={(e) => {
                      handleChange(e);
                      setPassword(e.target.value);
                    }}
                    autoComplete="off"
                    isInvalid={
                      touched.password && (!!errors.password || score < 3)
                    }
                  />
                  <i
                    className={`las pointer ${
                      passwordCanSee ? "la-eye" : "la-eye-slash"
                    }`}
                    onClick={() => setPasswordCanSee(!passwordCanSee)}
                  ></i>
                </div>
                <PasswordStrengthMeter
                  password={password}
                  action={(score) => setScore(score)}
                />
              </Form.Group>

              <Form.Group className="form-group" controlId="validationFormik3">
                <Form.Label>Confirm Password</Form.Label>
                <div className="input-holder right">
                  <Form.Control
                    type={passwordConfirmationCanSee ? "text" : "password"}
                    name="password_confirmation"
                    placeholder="Enter your confirmation password"
                    className="form-control"
                    onChange={handleChange}
                    autoComplete="off"
                    isInvalid={
                      touched.password_confirmation &&
                      !!errors.password_confirmation
                    }
                  />
                  <i
                    className={`las pointer ${
                      passwordConfirmationCanSee ? "la-eye" : "la-eye-slash"
                    }`}
                    onClick={() =>
                      setPasswordConfirmationCanSee(!passwordConfirmationCanSee)
                    }
                  ></i>
                </div>
              </Form.Group>

              <Form.Group>
                <Form.Check
                  required
                  name="agree"
                  className="check-box"
                  label={
                    <p>
                      I agree to{" "}
                      <a
                        href="https://invalert.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-info"
                      >
                        terms
                      </a>{" "}
                      &{" "}
                      <a
                        href="https://invalert.com/terms-of-service"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-info"
                      >
                        conditions
                      </a>
                    </p>
                  }
                  onChange={handleChange}
                  isInvalid={touched.agree && !!errors.agree}
                  id="validationFormik0"
                />
              </Form.Group>

              <Button size="lg" type="submit" variant="info" className="w-100">
                sign up
                {loading && (
                  <div className="spinner-holder">
                    <Spinner animation="border" variant="white" size="sm" />
                  </div>
                )}
              </Button>
            </Form>
          )}
        </Formik>
      </div>

      <div className="d-flex align-items-center my-4">
        <div className="border-bottom mw-50 w-100"></div>
        <span className="fw-bold fs-7 mx-2">OR</span>
        <div className="border-bottom mw-50 w-100"></div>
      </div>

      <div className="d-flex flex-column flex-sm-row flex-lg-column flex-xxl-row gap-4">
        <GoogleLogin text="register with Google" />

        <AppleLogin text="register with Apple" />
      </div>

      <small className="mt-4">
        Already have an account?
        <Link to="/auth/login" className="text-info fw-bolder">
          login here
        </Link>
      </small>
    </>
  );
};

const mapDispatchToProps = {
  setUser,
};

Register.propTypes = {
  setUser: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Register);
